import { validates } from 'helpers'

const validDocument = (document: string) => {
  if (!document) return false
  validates.cnpj(document) || validates.cpf(document)
}

export default validDocument
